import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyFormPane from "../BsyFormPane";

class BsyMsgDataView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appid: props.appid || props.match.params.appid || window.FX.STATIC.APPID,
      data: props.match.params.dataid || window.FX.STATIC.DATAID,
      form: props.match.params.entryid || window.FX.STATIC.ENTRYID,
    };

    this.input = React.createRef();
  }

  componentDidMount = () => {
    const { appid, form, data } = this.state;
    let that = this;
    React.axios("/data/read", {
      appId: appid,
      entryId: form,
      formId: form,
      dataId: data,
      iseditable: false,
      popupFormPath: [
        {
          ismsg: true,
          formId: form,
          appId: appid,
          entryId: form,
        },
      ],
    })
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            var d = res.data;
            var g = that._getFields(d);
            let config = {
              appId: appid,
              formId: form,
              entryId: form,
              ptlist: [],
              hasFlow: !d.hasCoop && d.hasFlow,
              hasShareBtn: !1,
              width: 1080,
              fieldShowRules: res.data.form.fieldShowRules,
              subformFieldShowRules: res.data.form.subformFieldShowRules,
              authGroupId: 0,
              widgetId: undefined,
              popupFormPath: undefined,
              forms: [form],
              fields: BsyUtils.isObjectEmpty(g) ? d.fields : g,
              header: BsyUtils.isObjectEmpty(g) ? d.fields : g,
              items: d.form.items,
              form: d.form,
              data: d.data,
              optAuth: d.optAuth,
              multiTabs: d.formTabs,
              formTabsStyle: d.formTabsStyle || {},
              dataId: data,
              title: "",
              height: "100%",
              dataCount: 0,
              needFetchViewData: false,
              dataIndex: null,
              hasSwitchBtn: false,
              hasCustomPrint: false,
              hasPrintBtn: d.hasPrintBtn,
              hasEditBtn: d.hasEditBtn,
              hasDeleteBtn: d.hasDeleteBtn,
              hasLog: d.hasLog,
              hasComment: d.hasComment,
              hasFlowLog: !d.hasCoop && d.hasFlow && d.flow_log,
              hasLogView: d.hasLogView,
              hasFlowBtn: d.hasFlow && !d.hasRecoverBtn,
              flow_activate: d.hasFlow && d.flow_activate,
              onSwitchData: function () {
                return {};
              },
            };
            // TODO 外链所有的操作都关闭
            if (this.isExternal) {
              Object.assign(config, {
                hasPrintBtn: false,
                hasEditBtn: false,
                hasDeleteBtn: false,
                hasLog: false,
                hasComment: false,
                hasFlowLog: false,
                hasLogView: false,
                hasFlowBtn: false,
                flow_activate: false,
              });
            }
            this.setState({ config: config });
          },
          () => {
            this.setState({
              status: "error",
              msg: res.data.msg,
            });
          }
        );
      })
      .catch((res) => {
        if (res && res.data && res.data.code == 400) {
          this.setState({
            status: "error",
            msg: res.data.msg,
          });
        } else {
          console.log(res);
        }
      });
  };

  _getFields = (d) => {
    const { form } = this.state;
    var // , d = this.options
      e = [],
      f = [];//["creator", "createTime", "updateTime", "_id", "label"];

    BsyUtils.forEach(d.form.items, function (f, g) {
      var h = { ...g };
      h.formId = form;
      var i = BsyUtils.getFieldAttr(h, window.FX.LimitFields.list);
      if (i) {
        if ("subform" === i.type) {
          var j = [];
          BsyUtils.forEach(i.items, function (a, b) {
            if (d.showFields)
              d.showFields.indexOf([i.name, b.name].join(".")) > -1 &&
                j.push(b);
            else if (d.fields) {
              var sname = [i.name, b.name].join(".");
              if (d.fields.hasOwnProperty(sname) && !!d.fields[sname].visible)
                j.push(b);
            } else j.push(b);
          });
          i.items = j;
          // if (d.showFields) {
          //   d.showFields.indexOf(i.name) > -1 && j.length >0 && e.push(i)
          // } else if (d.fields) {
          //   if (d.fields.hasOwnProperty(i.name) && j.length >0 && !!d.fields[i.name].visible)
          //     e.push(i)
          // } else {
          //   e.push(i)
          // }
          // if (j.length) {
          //   e.push(i)
          // }
          //外链出现问题
        }
        if (d.showFields) {
          let name =
            i.type === "subform" && i.items.length
              ? [i.name, i.items[0].name].join(".")
              : i.name;
          d.showFields.indexOf(name) > -1 && e.push(i);
        } else if (d.fields) {
          if (d.fields.hasOwnProperty(i.name) && !!d.fields[i.name].visible)
            e.push(i);
        } else {
          e.push(i);
        }
      }
    });
    e.concat(g);
    // if (d.hasFlow) {
    //   if (window.FX.STATIC.DECISION_SWITCH) {
    //     f.push("flowState", "flowdecision", "chargers");
    //   } else {
    //     f.push("flowState", "chargers");
    //   }
    // }
    d.hasUserSource && f.push("ext");
    var g = [];
    var ne = e;
    BsyUtils.forEach(f, function (a, b) {
      if (b === "label") {
        var s = BsyUtils.createEntryAttributeField(b, {
          entryId: form,
        });
        if (d.showFields) d.showFields.indexOf(s.name) > -1 && ne.unshift(s);
        else if (d.fields) {
          if (d.fields.hasOwnProperty(s.name) && !!d.fields[s.name].visible)
            ne.unshift(s);
        } else ne.unshift(s);
        return;
      }
      var e = BsyUtils.createEntryAttributeField(b, {
        entryId: form,
      });
      if (d.showFields) d.showFields.indexOf(e.name) > -1 && g.push(e);
      else if (d.fields) {
        if (d.fields.hasOwnProperty(e.name) && !!d.fields[e.name].visible)
          g.push(e);
      } else g.push(e);
    });
    e = e.concat(g);
    return e;
  };

  render() {
    const { config, status, msg } = this.state;

    return (
      <div className="bsy-data-view" id="EntryDataView" ref={this.input}>
        {status == "error" ? (
          <>
            <div className="header">{React.language("view.data")} </div>
            <div className="content">
              <div className="content-empty">
                <div className="empty-img"></div>
                <div
                  className="empty-tip"
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
              </div>
            </div>
          </>
        ) : BsyUtils.isObjectEmpty(config) ? (
          ""
        ) : (
          <BsyFormPane {...config} mode={"view"} onClose={() => {}} />
        )}
      </div>
    );
  }
}

export default withRouter(BsyMsgDataView);
